import { Component, Game, game } from 'cc';

export default abstract class BackgroundSleeper extends Component {
    private _awake = true;

    public get awake() {
        return this._awake;
    }
    public set awake(flag: boolean) {
        if (this._awake === flag) {
            return;
        }
        this._awake = flag;
        if (this.enabledInHierarchy) {
            if (flag) {
                this.registerAwakeCallback();
                this.onAwake();
            } else {
                this.unregisterAwakeCallback();
                this.onSleep();
            }
        }
    }

    protected onLoad() {
        backgroundSleeperList.push(this);
    }

    protected onEnable() {
        if (this.awake) {
            this.registerAwakeCallback();
            this.onAwake();
        }
    }

    protected onDisable() {
        if (this.awake) {
            this.unregisterAwakeCallback();
            this.onSleep();
        }
    }

    protected onDestroy() {
        const index = backgroundSleeperList.findIndex((view) => view === this);
        backgroundSleeperList.splice(index, 1);
        this.unregisterAwakeCallback();
    }

    protected abstract registerAwakeCallback(): void;

    protected abstract unregisterAwakeCallback(): void;

    protected abstract onAwake(): void;

    protected abstract onSleep(): void;
}

const backgroundSleeperList: BackgroundSleeper[] = [];
game.on(Game.EVENT_HIDE, () => {
    backgroundSleeperList.forEach((view) => {
        view.awake = false;
    });
});
game.on(Game.EVENT_SHOW, async () => {
    backgroundSleeperList.forEach((view) => {
        view.awake = true;
    });
});
